/* ZAR Earthy theme JS */

/* Announcement rotator */
(function () {
  const msgs = document.querySelectorAll('.announce .a-msg');
  if (msgs.length < 2) return;
  let i = 0;
  function show(n) { msgs.forEach(m => m.classList.remove('on')); i = (n + msgs.length) % msgs.length; msgs[i].classList.add('on'); }
  const p = document.querySelector('.a-prev'), nx = document.querySelector('.a-next');
  if (p) p.addEventListener('click', () => show(i - 1));
  if (nx) nx.addEventListener('click', () => show(i + 1));
  setInterval(() => show(i + 1), 5000);
})();

/* Greeting */
(function () {
  const el = document.getElementById('greetTxt');
  if (!el) return;
  const h = new Date().getHours();
  el.textContent = h < 12 ? 'Good morning, beautiful. ☀️' : h < 18 ? 'Good afternoon, beautiful. ✨' : 'Good evening, beautiful. 🌙';
})();

/* Hero slideshow */
(function () {
  const box = document.querySelector('.heroslides');
  if (!box) return;
  const slides = box.querySelectorAll('.slide');
  const dotsBox = box.querySelector('.hs-dots');
  if (!slides.length) return;
  let i = 0, timer;
  slides.forEach((_, n) => { const b = document.createElement('button'); b.setAttribute('aria-label', 'Slide ' + (n + 1)); b.addEventListener('click', () => go(n, true)); dotsBox.appendChild(b); });
  const dots = dotsBox.querySelectorAll('button');
  function go(n, manual) {
    slides[i].classList.remove('on'); dots[i].classList.remove('on');
    i = (n + slides.length) % slides.length;
    slides[i].classList.add('on'); dots[i].classList.add('on');
    if (manual) restart();
  }
  function restart() { clearInterval(timer); if (slides.length > 1) timer = setInterval(() => go(i + 1), 6500); }
  const pv = box.querySelector('.hs-prev'), nx = box.querySelector('.hs-next');
  if (pv) pv.addEventListener('click', () => go(i - 1, true));
  if (nx) nx.addEventListener('click', () => go(i + 1, true));
  go(0); restart();
})();

/* Product rails */
document.querySelectorAll('.rail-outer').forEach(outer => {
  const rail = outer.querySelector('.rail');
  const p = outer.querySelector('.rail-prev'), n = outer.querySelector('.rail-next');
  if (p) p.addEventListener('click', () => rail.scrollBy({ left: -560, behavior: 'smooth' }));
  if (n) n.addEventListener('click', () => rail.scrollBy({ left: 560, behavior: 'smooth' }));
});

/* Mobile drawer */
(function () {
  const drawer = document.getElementById('drawer');
  const scrim = document.getElementById('scrim');
  const openBtn = document.getElementById('openDrawer');
  if (!drawer || !openBtn) return;
  const open = () => { drawer.classList.add('open'); scrim.classList.add('on'); };
  const close = () => { drawer.classList.remove('open'); scrim.classList.remove('on'); };
  openBtn.addEventListener('click', open);
  document.getElementById('closeDrawer').addEventListener('click', close);
  scrim.addEventListener('click', close);
})();

/* AJAX add-to-cart for quick-add forms */
document.querySelectorAll('.quick-form form, form.pdp-form').forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const orig = btn.textContent;
    btn.textContent = 'Adding…'; btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      if (!res.ok) throw 0;
      const cart = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
      btn.textContent = 'Added ✓';
    } catch (_) { btn.textContent = 'Error — try again'; }
    setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1600);
  });
});

/* PDP gallery */
(function () {
  const main = document.getElementById('GalleryMain');
  if (!main) return;
  document.querySelectorAll('.pdp .thumbs button').forEach(b => {
    b.addEventListener('click', () => {
      main.src = b.dataset.src;
      document.querySelectorAll('.pdp .thumbs button').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
    });
  });
})();

/* PDP variant select -> price/availability */
(function () {
  const sel = document.querySelector('.variant-select');
  if (!sel) return;
  const priceEl = document.querySelector('[data-price]');
  const idInput = document.querySelector('.pdp-form input[name="id"]');
  const btn = document.querySelector('.pdp-form [type="submit"]');
  sel.addEventListener('change', () => {
    const o = sel.selectedOptions[0];
    if (idInput) idInput.value = o.value;
    if (priceEl && o.dataset.price) priceEl.textContent = o.dataset.price;
    if (btn) { btn.disabled = o.dataset.available === 'false'; btn.textContent = o.dataset.available === 'false' ? 'Sold out' : 'Add to basket'; }
  });
})();

/* Qty steppers (PDP + cart) */
document.querySelectorAll('.qty').forEach(q => {
  const input = q.querySelector('input');
  q.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
    let v = parseInt(input.value || '1', 10) + (b.dataset.dir === 'up' ? 1 : -1);
    input.value = Math.max(parseInt(input.min || '0', 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }));
});

/* Cart line quantity change -> POST /cart/change */
document.querySelectorAll('[data-line-qty]').forEach(input => {
  input.addEventListener('change', async () => {
    const res = await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(input.dataset.lineQty, 10), quantity: parseInt(input.value, 10) })
    });
    if (res.ok) location.reload();
  });
});

/* Related products (recommendations) */
(function () {
  const holder = document.querySelector('[data-recommendations]');
  if (!holder) return;
  const url = holder.dataset.url;
  fetch(url).then(r => r.text()).then(html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const inner = doc.querySelector('[data-recommendations]');
    if (inner && inner.innerHTML.trim().length) holder.innerHTML = inner.innerHTML;
  }).catch(() => {});
})();

/* Reveal on scroll */
const zio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); zio.unobserve(e.target); } }), { threshold: .1 });
document.querySelectorAll('.rv').forEach(el => zio.observe(el));
